// #244 (04/08): a regra do "equivale a R$ X/mês" existia em UM lugar privado
// (o paywall de login) e era REPETIDA como string literal na página de compra
// ("Equivale a R$ 82,83/mês"). Os números literais estavam certos — 497/6 e
// 997/12 — mas hand-computados: no dia em que o preço mudasse, a página de
// vendas continuaria anunciando o rateio antigo, sem nada acusar.
//
// Fonte única da regra, para que preço e rateio nunca se desencontrem.
import { formatSaleMoneyCents } from "@/lib/format/currency";

/** Abaixo disto o rateio não informa nada: um plano de 30 dias "equivale" a si
 * mesmo, e um de 45 dias arredondaria para 1 mês e mentiria para baixo. */
export const MONTHLY_EQUIVALENT_MIN_DAYS = 60;

/** Meses cheios que uma janela em dias representa, para fins de rateio.
 * @example `equivalentMonths(180)` → `6` */
export function equivalentMonths(periodDurationDays: number): number {
  return Math.max(1, Math.round(periodDurationDays / 30));
}

/** Preço mensal equivalente, ou `null` quando o rateio não informa nada.
 *
 * Devolve só o valor formatado (`"R$ 82,83/mês"`), sem prefixo, para que cada
 * superfície escolha a própria moldura de frase.
 *
 * @example `monthlyEquivalentPrice(49700, 180)` → `"R$ 82,83/mês"`
 */
export function monthlyEquivalentPrice(
  amountCents: number,
  periodDurationDays: number | null | undefined,
): string | null {
  if (periodDurationDays === null || periodDurationDays === undefined)
    return null;
  if (periodDurationDays < MONTHLY_EQUIVALENT_MIN_DAYS) return null;
  const months = equivalentMonths(periodDurationDays);
  return `${formatSaleMoneyCents(Math.round(amountCents / months))}/mês`;
}
